import { useFormikContext } from 'formik';
import React, { ReactElement, ReactNode, useEffect, useState } from 'react';
import { Client, Entente, Lieu } from '../../../../../common/src/entities';
import { Button, Card, Col, Form, Row } from 'react-bootstrap';
import { LABEL_COL } from '../constantes';
import { Popout } from '../Utils/Popout';
import { ValueType } from 'react-select';
import ClientLieu from '../../../../../common/src/entities/client-lieu.entity';
import { affichageElementDefaut } from '../Thematiques/ChampMultipleDnd';
import { affichageLieu } from './DetailsLieu';
import { BiX } from 'react-icons/bi';
import LieuActivite from '../../../../../common/src/entities/lieu-activite.entity';

export interface PropsChampMultipleActiviteProduit {
    id: string;
    label: string;
    titreBouton: string;
    lieux: ClientLieu[] | LieuActivite[];
    placeholder: ReactNode;
    selectedLieu?: Lieu;
    oneLiner?: boolean;
    hideX?: boolean;
    disabled?: boolean;
    disableOnce?: boolean;
}

export default function ChampUniqueLieu(props: PropsChampMultipleActiviteProduit): ReactElement {
    const { setFieldValue } = useFormikContext<Client | Entente>();
    const [selectedLieu, setSelectedLieu] = useState<Lieu | null>(null);
    const [lieuDisplay, setLieuDisplay] = useState<{ label: string; name: string; id: number }[]>([]);
    const [once, setOnce] = useState<boolean>(false);

    const handleChange = (
        value: ValueType<
            {
                label: string;
                name: string;
                id: number;
            },
            false
        >,
    ) => {
        if (value && props.lieux) {
            const selectedLieu = (props.lieux as any[]).find((lieu) => lieu.lieu.id === value.id);
            if (selectedLieu) {
                setSelectedLieu(selectedLieu.lieu);
            }
        }
    };

    useEffect(() => {
        if (!once && props.selectedLieu) {
            setSelectedLieu(props.selectedLieu);
            setOnce(!props.disableOnce);
        }
    }, [props.selectedLieu]);

    const handleRemove = () => {
        setSelectedLieu(null);
    };

    useEffect(() => {
        if (props.lieux) {
            setLieuDisplay(
                (props.lieux as any[]).map((lieu) => ({
                    label: affichageLieu(lieu.lieu ?? lieu),
                    name: affichageLieu(lieu.lieu ?? lieu),
                    id: (lieu.lieu ?? lieu).id,
                })),
            );
        }
    }, [props.lieux]);

    useEffect(() => {
        setFieldValue(props.id, selectedLieu);
    }, [selectedLieu]);

    const cssCardBody: React.CSSProperties = {
        padding: 0,
        minHeight: 30,
        height: '30px',
        fontSize: '14px',
    };

    return (
        <Form.Group aria-disabled={props.disabled}>
            <Row>
                <Col xs={LABEL_COL}>{props.label}</Col>
                <Col>
                    {props.oneLiner ? (
                        <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: '10px' }}>
                            <div
                                className="selected-name"
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    border: '1px solid #ccc',
                                    borderRadius: '0.25rem',
                                    margin: 0,
                                    padding: '0 6px',
                                    fontSize: '14px',
                                }}
                            >
                                {selectedLieu ? affichageLieu(selectedLieu) : <i>{props.placeholder}</i>}{' '}
                                {selectedLieu && !props.hideX && (
                                    <Button
                                        variant="link"
                                        style={{ paddingTop: 0, paddingBottom: 0 }}
                                        className="d-none d-sm-flex align-items-center text-muted px-0"
                                        onClick={() => handleRemove()}
                                    >
                                        <BiX size="1.25em" />
                                    </Button>
                                )}
                            </div>
                            <div className="p-0">
                                {!props.disabled && (
                                    <Popout
                                        id="btnLieu"
                                        titre={props.titreBouton}
                                        entite={Lieu}
                                        size="sm"
                                        options={lieuDisplay}
                                        onChange={handleChange}
                                        avecUnBouton
                                    />
                                )}
                            </div>
                        </div>
                    ) : (
                        <Row>
                            <Col>
                                <Card>
                                    <Card.Body style={cssCardBody}>
                                        <div>
                                            <div>
                                                {affichageElementDefaut(Lieu)(
                                                    selectedLieu,
                                                    null,
                                                    null,
                                                    () => (selectedLieu ? affichageLieu(selectedLieu) : 'Aucun lieu'),
                                                    handleRemove,
                                                    { height: '30px' },
                                                )}
                                            </div>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    )}
                </Col>
            </Row>
            {!props.oneLiner && (
                <Row>
                    <Col xs={LABEL_COL}></Col>
                    <Col className="pt-2">
                        <Popout
                            id={`btnLieu`}
                            titre={props.titreBouton}
                            entite={Lieu}
                            size="sm"
                            options={lieuDisplay}
                            onChange={handleChange}
                            avecUnBouton
                        />
                    </Col>
                </Row>
            )}
        </Form.Group>
    );
}
